import request from '../../../utils/Request';
import { Methods } from '../../../config';

const baseURL = 'langi/calendar';

const lngCalendarService = {
  getCalendarDays: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },
};
export default lngCalendarService;
